import { IconButton } from '@mui/material';
import {
  CcfDispositionInteractionIcon,
  CcfDoubleArrowIcon,
  CcfDraggableIcon,
  CcfOverflowIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { Contact } from '../../ccf-inbox/model/contact';
import { useSelector } from 'react-redux';
import { activeContactSelector } from '../../ccf-inbox/ccf-inbox.slice';

interface CcfDispositionHeaderProps {
  isDispositionCompleted?: boolean;
  isDispositionOpen: boolean;
  activeContact?: Contact;
}

/**
 * Component to display disposition header
 * @param param - CcfDispositionHeaderProps
 * @returns - display disposition header
 * @example CcfDispositionHeader
 */
export function CcfDispositionHeader({
  isDispositionCompleted,
  isDispositionOpen,
  activeContact,
}: CcfDispositionHeaderProps) {
  const activecontact = useSelector(activeContactSelector);
  const isCopilotSourceLiveLLM = activecontact?.copilotSource === 'Live LLM';
  return (
    <>
      <CcfDraggableIcon />
      <CcfDispositionInteractionIcon
        className={
          isDispositionCompleted ? 'dispositionCompleted' : 'dispositionPending'
        }
      />
      <CcfTypography variant="inherit" className="textOutcomes">
        {isDispositionOpen &&
          `${[
            activeContact?.customer?.firstName,
            activeContact?.customer?.middleName,
            activeContact?.customer?.lastName,
          ]
            .filter(Boolean)
            .join(' ')}`+ ' |'}{' '}
        <CcfTypography variant="inherit" translationKey="outcomes" />
      </CcfTypography>
      {isDispositionOpen ? (
        <IconButton style={isCopilotSourceLiveLLM ? {marginLeft:'300px'} : {}}>
          <CcfOverflowIcon className="popOverFlow" />
        </IconButton>
      ) : (
        <CcfDoubleArrowIcon style={isCopilotSourceLiveLLM ? {marginLeft:'300px'} : {}} />
      )}
    </>
  );
}

export default CcfDispositionHeader;
